// extracted by mini-css-extract-plugin
export default {"root":"IconCarouselArrows_root__URFgo"};